<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section" id="sect1"><a id="page4"></a><span href="#/OEBPS/toc#sect1" title="Link target outside of Sample">Banana Nut Bread</span></h1>
<p class="figure"><img alt="" src="OEBPS/images/5-1.jpg" style="height:70vh"/></p>
<p class="RecipebYieldb">Yield: Serves 12 | Prep Time: 10 minutes | Cook Time: 45–55 minutes</p>
<p class="extract_r">Applesauce is such an easy alternative to use when you’re looking to lighten up a recipe. It’s often used to replace oil in baking. It’s just as yummy but cuts back on fat and calories (with no added sugar)! And as a bonus, the almond flour makes this recipe gluten-free!</p>
<p class="ingredients"><strong>INGREDIENTS</strong></p>
<p class="rec">2 ripe bananas</p>
<p class="rec">3 large eggs, room temperature</p>
<p class="rec">½ cup applesauce</p>
<p class="rec">2 tablespoons vegetable or canola oil</p>
<p class="rec">2¼ cups almond flour</p>
<p class="rec">1 tablespoon baking powder</p>
<p class="rec">1 teaspoon cinnamon</p>
<p class="rec">½ teaspoon kosher salt</p>
<p class="rec">½ cup chopped pecans</p>
<p class="rec">1 teaspoon vanilla extract</p>
<p class="directions"><strong>DIRECTIONS</strong></p>
<p class="recpr">1. Preheat the oven to 350°F. Coat a 9 × 5-inch loaf pan with cooking spray. Line the bottom of the pan with parchment paper and coat with cooking spray again.</p>
<p class="recpr">2. Mash the bananas and place into a 2-cup liquid measuring cup.</p>
<p class="recpr">3. Add the eggs, applesauce, and vegetable oil to the bananas. Stir to blend. Add enough water to fill the measuring cup of wet ingredients to 2 cups.</p>
<p class="recpr">4. In a medium bowl, combine the flour, baking powder, cinnamon, and salt.</p>
<p class="recpr">5. Add the wet ingredients to the dry ingredients and mix just until combined. Do not overmix.</p>
<p class="recpr">6. Stir in the pecans and vanilla.</p>
<p class="recpr">7. Pour the batter into the prepared loaf pan and bake for 45 to 55 minutes until golden.</p>
<p class="recpr">8. Place the bread, in the pan, on a wire rack to cool for 15 minutes.</p>
<p class="recpr">9. Run a knife or flat metal spatula around the pan. Carefully turn the bread out of the pan onto the rack to cool further. Slice and serve.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sect1.vue?a30a7a4a